import React from "react";
import CrearIdentificacion from "../components/Parametros/CrearIdentificacion";

const AddIdentificationPage = () => {
  return <CrearIdentificacion />;
};

export default AddIdentificationPage;
